<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrando</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="10"
          >
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="vendedor"
                class="invoice-filter-select-vendedor d-inline-block mr-1"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="nombreCompleto"
                :options="selectVendedor"
                @input="changeVendedorFilter"
              />
              <div
                class="d-flex align-items-center"
                style="width: 30vh"
              >
                <feather-icon
                  icon="CalendarIcon"
                  size="16"
                />
                <flat-pickr
                  v-model="rangePicker"
                  :config="pickerConfig"
                  class="form-control flat-picker bg-transparent border-0 shadow-none"
                  placeholder="YYYY-MM-DD"
                  @on-change="changeFechaVenta"
                />
              </div>
              <b-form-input
                v-model="query"
                class="d-inline-block mx-50 mr-1"
                style="width: 50vh;"
                placeholder="Buscar..."
              />
              <v-select
                v-model="statusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="descripcion"
                :options="statusOptions"
                class="invoice-filter-select d-inline-block mr-1"
                placeholder="Filtros Ose"
                @input="chageStatusFilter"
              />
              <!-- <b-button
                class="mr-50"
                variant="success"
                @click="generarReportes()"
              >
                <span class="text-nowrap">Reportes</span>
              </b-button> -->
              <b-button
                :disabled="isBusy"
                variant="primary"
                @click="openForm('new')"
              >
                <span class="text-nowrap">Nuevo</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="items"
        responsive
        :fields="fields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
        </template>
        <template #cell(razonSocial)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="`data:image/jpeg;base64,${data.item.foto}`"
                :text="avatarText(`${data.item.razonSocial}`)"
                :variant="`light-${getColorAvatar()}`"
              />
            </template>
            <span class="font-weight-bold d-block text-nowrap">
              {{ data.item.razonSocial }}
            </span>
            <small class="text-muted">{{ data.item.representanteLegal }}</small>
            <small class="text-muted d-block ">{{ data.item.tipoDocumento.abreviatura }} {{ data.item.documento }}</small>
          </b-media>
        </template>
        <!-- Column: estado_sunat -->
        <template #cell(estado_sunat)="data">
          <b-row>
            <!-- Columna 1: Estado Sunat -->
            <b-col cols="12">
              <b-badge
                v-if="data.item.repuestaOse == null && data.item.tipoDocumento.tipoDocumentoId !== 12"
                variant="primary"
              >
                Pendiente
              </b-badge>
              <b-badge
                v-if="data.item.repuestaOse != null && data.item.tipoDocumento.tipoDocumentoId !== 12"
                variant="success"
              >
                Enviado
              </b-badge>
              <b-badge
                v-if="data.item.totalFacturadoTicket == 0 && data.item.tipoDocumento.tipoDocumentoId === 12"
                variant="danger"
              >
                Pendiente
              </b-badge>
              <b-badge
                v-if="data.item.isSucursal == true && data.item.tipoDocumento.tipoDocumentoId === 12"
                variant="warning"
              >
                Traslado
              </b-badge>
              <b-badge
                v-if="data.item.totalFacturadoTicket > 0 && data.item.tipoDocumento.tipoDocumentoId === 12"
                variant="success"
              >
                Facturado
              </b-badge>
            </b-col>

            <!-- Columna 2: Vendedor -->
            <b-col cols="12">
              <span
                v-if="data.item.tipoDocumento.tipoDocumentoId === 12"
                class="font-weight-bolder mr-1 ml-1"
              >S/{{ parseFloat(data.item.totalFacturadoTicket ).toFixed(2) }}</span>
              <small
                v-if="data.item.vendedor != null"
                class="font-weight-bolder"
              >
                {{ formatNameVendedor(data.item.vendedor.trabajador.nombreCompleto) }}
              </small>
            </b-col>
          </b-row>
        </template>
        <!-- Column: estado_venta -->
        <template #cell(estado_venta)="data">
          <div class="d-flex align-items-center">
            <div>
              <div class="font-small-4 font-weight-bolder">
                <b-badge
                  v-if="data.item.fechaAnulacion == null"
                  variant="success"
                >
                  Vigente
                </b-badge>
                <b-badge
                  v-if="data.item.fechaAnulacion != null"
                  variant="danger"
                >
                  Anulado
                </b-badge>
              </div>
              <div class="font-small-3 text-muted">
                {{ data.item.fechaAnulacion }}
              </div>
            </div>
          </div>

        </template>
        <!-- Column: tipoPago -->
        <template #cell(tipoPago)="data">
          <div class="d-flex align-items-center">
            <div>
              <div class="font-small-4 font-weight-bolder">
                <b-badge
                  v-if="data.item.tipoPago == 'COMPLETO' || data.item.tipoPago == null"
                  variant="primary"
                >
                  COMPLETO
                </b-badge>
                <b-badge
                  v-if="data.item.tipoPago == 'BONO_FISE'"
                  variant="success"
                >
                  {{ data.item.tipoPago }}
                </b-badge>
              </div>
            </div>
          </div>

        </template>
        <!-- Column: tipoPago -->
        <template #cell(totalFise)="data">
          <div class="d-flex align-items-center">
            <div>
              <div
                v-if="data.item.tipoPago == 'BONO_FISE'"
                class="font-small-4 font-weight-bolder"
              >
                S/{{ data.item.totalFise!==null ? parseFloat(data.item.totalFise).toFixed(2) : 0 }}
              </div>
              <div
                v-if="data.item.tipoPago !== 'BONO_FISE'"
                class="font-small-4 font-weight-bolder"
              >
                S/ 0.00
              </div>
            </div>
          </div>

        </template>
        <!-- Column: Actions -->
        <template #cell(acciones)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="data.item.fechaAnulacion == null && esHoy(data.item.fechaVenta)"
              @click="deleteVenta(data)"
            >
              <feather-icon icon="XSquareIcon" />
              <span class="align-middle ml-50">Anular</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.repuestaOse != null"
              target="_blank"
              :href="data.item.repuestaOse == null ?'':'https://www.nubefact.com/see_invoice/'+data.item.repuestaOse.keyOse+'?view=true'"
              @click="getPrintPdf(data)"
            >
              <feather-icon icon="PrinterIcon" />
              <span class="align-middle ml-50">PDF, XML Y CDR</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.repuestaOse != null && data.item.fechaAnulacion == null"
              @click="generarNota(data)"
            >
              <feather-icon icon="BookIcon" />
              <span class="align-middle ml-50">Anular Nota Credito</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.rutaNotaCredito != null && data.item.fechaAnulacion != null"
              target="_blank"
              :href="data.item.rutaNotaCredito"
            >
              <feather-icon icon="BookIcon" />
              <span class="align-middle ml-50"> Pdf Nota Credito</span>
            </b-dropdown-item>
            <!-- <b-dropdown-item
              v-if="data.item.tipoPago == 'BONO_FISE'"
              @click="getControlFise(data)"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Control Fise</span>
            </b-dropdown-item> -->
            <b-dropdown-item
              v-if="data.item.tipoDocumento.descripcion == 'TICKET' && data.item.isSucursal == false"
              @click="getControlFise(data)"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Facturacion Pendiente</span>
            </b-dropdown-item>
            <b-dropdown-item
              @click="getPrintPdfTicke(data)"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">PDF</span>
            </b-dropdown-item>
            <!-- v-if="data.item.tipoDocumento.descripcion == 'TICKET'" -->
            <!-- <b-dropdown-item
              v-if="data.item.repuestaOse == null && data.item.tipoDocumento.descripcion !== 'TICKET'"
              target="_blank"
              :href="data.item.repuestaOse == null ?'':data.item.repuestaOse.rutaPdf"
              @click="getConsultaOse(data)"
            >
              <feather-icon icon="PrinterIcon" />
              <span class="align-middle ml-50">Consultar Ose</span>
            </b-dropdown-item> -->
            <b-dropdown-item
              v-if="data.item.repuestaOse == null && data.item.tipoDocumento.descripcion !== 'TICKET'"
              target="_blank"
              :href="data.item.repuestaOse == null ?'':data.item.repuestaOse.rutaPdf"
              @click="getReenvioOse(data)"
            >
              <feather-icon icon="PrinterIcon" />
              <span class="align-middle ml-50">Consultar Ose</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if=" (data.item.clienteId !== null && data.item.clienteId !== 0) && data.item.tipoPago == 'COMPLETO' && data.item.tipoDocumento.descripcion == 'BOLETA'"
              @click="asignarFise(data)"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Asignar Fise</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.tipoDocumento.descripcion == 'FACTURA' || data.item.tipoDocumento.descripcion == 'BOLETA'"
              @click="asignarDelivery(data)"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Asignar Deliverista</span>
            </b-dropdown-item>

            <!-- <b-dropdown-item @click="getEdit(data)">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Ver</span>
            </b-dropdown-item>

            <b-dropdown-item @click="getEdit(data)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>

            <b-dropdown-item @click="getDelete(data)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Eliminar</span>
            </b-dropdown-item> -->
          </b-dropdown>
        </template>
        <template #cell(totalFormat)="data">
          <span class="font-weight-bolder"> {{ formatearMoneda(data.item.total) }}</span>
        </template>
        <template #cell(comprobante)="data">
          <div class="d-flex align-items-center">
            <div>
              <div class="font-small-4 font-weight-bolder">
                {{ data.item.numeroComprobante }}
                <b-link
                  v-if="data.item.delivery!== null"
                  v-b-tooltip.hover.top="`${data.item.delivery.nombreCompleto}`"
                  class="font-weight-bold"
                >
                  <b-avatar
                    size="32"
                    :variant="`light-success`"
                  >
                    <feather-icon
                      icon="TruckIcon"
                      size="20"
                    />
                  </b-avatar>
                </b-link>
              </div>
              <div class="font-small-3 text-muted">
                {{ data.item.fechaVenta }}
              </div>
            </div>
          </div>
        </template>
        <template #cell(clienteTemplate)="data">
          <div class="d-flex align-items-center">
            <div>
              <div class="font-small-3 font-weight-bolder">
                {{ data.item.clienteNombre }}
              </div>
              <div class="font-small-2 text-muted">
                {{ data.item.clienteRuc.length==11?'RUC':'DNI' }}: {{ data.item.clienteRuc }}
              </div>
              <div class="font-small-2 text-muted">
                {{ data.item.clienteDireccion }}
              </div>
            </div>
          </div>
        </template>
        <template #cell(clienteFinalTemplate)="data">
          <div class="d-flex align-items-center">
            <div>
              <div
                v-if="data.item.clienteFinal !== null"
                class="font-small-3 font-weight-bolder"
              >
                {{ data.item.clienteFinal.nombreComercial }}
              </div>
              <div
                v-if="data.item.clienteFinal !== null"
                class="font-small-2 text-muted"
              >
                {{ data.item.clienteRuc.length==11?'RUC':'DNI' }}: {{ data.item.clienteRuc }}
              </div>
              <div
                v-if="data.item.clienteFinal === null"
                class="font-small-4 text-muted"
              >
                <strong>No registro Cliente</strong>
              </div>
            </div>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="page"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <b-modal
      ref="my-modal"
      hide-footer
      title=""
    >
      <div class="d-block">
        <h4 class="text-center">
          REPORTES DE LOS LIBROS Y/O REGISTROS ELECTRÓNICOS</h4>
        <div>
          <b-form-select
            v-model="selectedPeriodo"
            :options="options"
            size="sm"
            class="mt-1 mb-2"
          />
          <b-form-radio
            v-model="tipoRepo"
            plain
            name="some-radios3"
            value="op1"
            class="mb-2"
          >
            REGISTRO DEL INVENTARIO PERMANENTE EN UNIDADES FÍSICAS
          </b-form-radio>
          <b-form-radio
            v-model="tipoRepo"
            plain
            name="some-radios3"
            value="op2"
          >
            REGISTRO DEL INVENTARIO PERMANENTE VALORIZADO
          </b-form-radio>
          <b-form-radio
            v-model="tipoRepo"
            plain
            name="some-radios3"
            value="op3"
          >
            REGISTRO DE VENTA CONTASIS
          </b-form-radio>
        </div>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="mt-2"
        variant="primary"
        block
        @click="initReporte"
      >
        Generar
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="mt-3"
        variant="secondary"
        block
        @click="hideModal"
      >
        Cerrar
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BDropdown, BDropdownItem, BPagination, BSpinner, BAvatar, BMedia, VBTooltip, BBadge, BFormRadio, BFormSelect,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { jsPDF } from 'jspdf'
import { showToast, showError } from '@/helpers'
import { avatarText } from '@core/utils/filter'
import exportFromJSON from 'export-from-json'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import QRCode from 'qrcode'

// import cliente from '@/store/modules/comercial/actions/cliente'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,
    BFormRadio,
    vSelect,
    BSpinner,
    BAvatar,
    BMedia,
    BFormSelect,
    flatPickr,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },

  data: () => ({
    isBusy: false,
    idEmpresa: 3,
    isToggleSidebar: false,
    isloadRowList: true,
    dataEdit: {},
    formType: '',
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    totalPage: 0,
    from: 0,
    to: 0,
    of: 0,
    pageOptions: [10, 20, 50, 150, 300],
    sortBy: null,
    selected: null,
    sortDesc: false,
    sortDirection: 'asc',
    query: '',
    vendedor: null,
    idVendedorFiltro: '-1',
    fechaInicio: '',
    fechaFin: '',
    tipoRepo: '',
    items: [],
    itemsExportExcel: [],
    statusFilter: { id: '-1', descripcion: 'Todos' },
    statusOptions: [
      { id: '-1', descripcion: 'Todos' },
      // { id: '1', descripcion: 'Enviados' },
      { id: '2', descripcion: 'Pendientes' },
      // { id: '3', descripcion: 'Vigentes' },
      // { id: '4', descripcion: 'Anulados' },
    ],
    userProfile: localStorage.getItem('userProfile'),
    fields: [
      { key: 'ventaId', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'comprobante', label: 'Comprobante', sortable: true },
      { key: 'clienteTemplate', label: 'Cliente Sunat', sortable: true, tdClass: 'w180', thClass: 'w180' },
      { key: 'clienteFinalTemplate', label: 'Cliente Real', sortable: true, tdClass: 'w180', thClass: 'w180' },
      // { key: 'numeroComprobante', label: 'Nro.Comprobante', sortable: true },
      // { key: 'formatoPago.descripcion', label: 'F. Pago', sortable: true, tdClass: 'text-center', thClass: 'text-center' },
      { key: 'tipoVenta.descripcion', label: 'T. Venta', sortable: true },
      { key: 'totalFormat', label: 'Total', sortable: true },
      { key: 'tipoPago', label: 'Tipo Pago', sortable: true },
      { key: 'totalFise', label: 'Total Fise', sortable: true },
      { key: 'estado_venta', label: 'Estado' },
      { key: 'estado_sunat', label: 'Sunat' },
      { key: 'acciones' },
    ],
    selectedPeriodo: null,
    options: [],
    selectVendedor: [],
    userData: JSON.parse(localStorage.getItem('userData')),
    rangePicker: [],
    pickerConfig: {
      mode: 'range',
      altInput: true,
      altFormat: 'Y-m-d',
      dateFormat: 'Y-m-d',
      formatDate: date => moment(date).format('YYYY-MM-DD'),
      formatRange: (dateObj1, dateObj2) => {
        const start = moment(dateObj1).format('YYYY-MM-DD')
        const end = moment(dateObj2).format('YYYY-MM-DD')
        return `${start} A ${end}`
      },
    },
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
    this.vendedorDefault()
  },
  methods: {
    esHoy(fechaStr) {
      if (!fechaStr) return false

      // formato: '22/11/2025 08:56:14'
      const [fecha] = fechaStr.split(' ')
      const [dia, mes, anio] = fecha.split('/').map(Number)

      const fechaVenta = new Date(anio, mes - 1, dia)
      const hoy = new Date()

      return (
        fechaVenta.getFullYear() === hoy.getFullYear() && fechaVenta.getMonth() === hoy.getMonth() && fechaVenta.getDate() === hoy.getDate()
      )
    },
    tienePerfil(nombrePerfil) {
      const lista = JSON.parse(localStorage.getItem('listPerfiles'))
      return lista.some(item => item.perfil === nombrePerfil)
    },
    async vendedorDefault() {
      // console.info('listPerfiles', JSON.parse(localStorage.getItem('listPerfiles')))
      // this.userData.authorities[0].authority === 'VENDEDOR NCAJAMARCA' || this.userData.authorities[0].authority === 'VENDEDOR CILINDROS' || this.userData.authorities[0].authority === 'VENDEDOR GRANEL' || this.userData.authorities[0].authority === 'VENDEDOR DEPOSITO' || this.userData.authorities[0].authority === 'VENDEDOR GASOCENTRO' || this.userData.authorities[0].authority === 'CONTADOR'
      if (this.tienePerfil(this.userData.authorities[0].authority)) {
        this.selectVendedor.push({ idUsuario: this.userData.id, nombreCompleto: this.userData.nombreCompleto })
        this.vendedor = { idUsuario: this.userData.id, nombreCompleto: this.userData.nombreCompleto }
      } else {
        this.selectVendedor = []
        this.selectVendedor.push({ idUsuario: '-1', nombreCompleto: 'TODOS' })
        await store.dispatch('seguridad/USUARIO_ALL_SALES', { tipo_usuario: '-' })
          .then(response => {
            // console.log(response)
            response.forEach(value => {
              const { trabajador, ...resto } = value
              const nuevoObjeto = {
                nombreCompleto: trabajador.nombreCompleto,
                ...resto,
                trabajador,
              }
              this.selectVendedor.push(nuevoObjeto)
            })
            this.selectVendedor.push({ idUsuario: this.userData.id, nombreCompleto: this.userData.nombreCompleto })
            this.vendedor = { idUsuario: '-1', nombreCompleto: 'TODOS' }
          })
        // console.log(this.selectVendedor)
      }
    },
    exporDataExcel(rows, periodo) {
      console.log(periodo)
      const fileName = 'REGISTRO_VENTA_CONTASIS' // `REGISTRO DE VENTA CONTASIS`
      const exportType = exportFromJSON.types.xls
      const data = []
      rows.forEach(row => {
        const fechaVencimiento = row.fechaVencimiento === null ? '' : row.fechaVencimiento
        const tipoComprobante = row.tipoDocumento.codigo
        const partComprobanteRepo = (row.numeroComprobante).split('-')
        const nSerieComprobante = partComprobanteRepo[0]
        const numeroComprobante = partComprobanteRepo[1]
        const partCliente = (row.clienteDato).split('|')
        const clienteTipoDocumento = partCliente[2].length === 8 ? '1' : '6'
        const clienteNumero = partCliente[2]
        const clienteNombre = partCliente[0]
        const valorExonerada = row.total
        const baseOperacionGravada = '0'
        const totalExonedara = row.total
        const totalInafecta = '0'
        const totalIgv = row.montoIgv
        const otrosTributos = '0'
        const importeComprobante = row.total
        const tipoCambio = '0'
        const rowData = { fechaVenta: row.fechaVenta, fecha_vencimiento: fechaVencimiento, tipo_comprobante: tipoComprobante, nserie_comprobante: nSerieComprobante, numero_comprobante: numeroComprobante, cliente_tipo_documento: clienteTipoDocumento, cliente_numero: clienteNumero, cliente_nombre: clienteNombre, valor_exonerada: valorExonerada, base_operacion_gravada: baseOperacionGravada, total_exonedara: totalExonedara, total_inafecta: totalInafecta, total_igv: totalIgv, otros_tributos: otrosTributos, importe_comprobante: importeComprobante, tipo_cambio: tipoCambio }
        data.push(rowData)
      })
      // console.log(data)
      const withBOM = true
      exportFromJSON({ data, fileName, exportType, withBOM })
    },
    initReporte() {
      Vue.swal({
        title: 'Generando el archivo',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          Vue.swal.showLoading()
          if (this.tipoRepo === 'op3') {
            await store
              .dispatch('comercial/VENTAS_FIND_ALL', {
                idEmpresa: this.idEmpresa,
                limit: 1000000,
                query: '',
                page: 1,
                almacen: -1,
                sortBy: 'ventaId%7CDESC',
                filtro_venta: this.statusFilter.id,
                periodo: this.selectedPeriodo,
              })
              .then(response => {
                const data = response.items
                this.exporDataExcel(data, this.selectedPeriodo)
                Vue.swal.close()
                this.$refs['my-modal'].hide()
              })
              .catch(error => {
                this.showToast('Ha ocurrido un error', error, 'danger')
              })
          } else {
            await store.dispatch('comercial/REPORTES_CONTABLE', { periodo: this.selectedPeriodo, tipo: this.tipoRepo })
              .then(response => {
                console.log(response)
                const contenido = response.join('\n')
                const a = document.createElement('a')
                const archivo = new Blob([contenido], { type: 'text/plain' })
                const url = URL.createObjectURL(archivo)
                a.href = url
                let codigoRepo = '1301'
                if (this.tipoRepo === 'op2') {
                  codigoRepo = '1201'
                }
                a.download = `LE20362013802${this.selectedPeriodo}00${codigoRepo}00001111`
                a.click()
                URL.revokeObjectURL(url)
                Vue.swal.close()
                this.$refs['my-modal'].hide()
              })
          }
        },
      })
    },
    generarReportes() {
      Vue.swal({
        title: 'Obteniendo Parametros',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          Vue.swal.showLoading()
          await store.dispatch('comercial/REPORTES_PARAMETERS', {
          })
            .then(response => {
              this.options = response.periodos
              this.$refs['my-modal'].show()
            })
          Vue.swal.close()
        },
      })
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
    getPrintPdf(data) {
      if (data.item.repuestaOse !== null) {
        console.log(data.item.repuestaOse.rutaPdf)
      }
    },
    async listarRegistros() {
      // console.log(this.userProfile)
      // this.idVendedorFiltro = '-1'
      // this.userData.authorities[0].authority === 'VENDEDOR CILINDROS' || this.userData.authorities[0].authority === 'VENDEDOR GRANEL' || this.userData.authorities[0].authority === 'VENDEDOR DEPOSITO'
      if (this.tienePerfil(this.userData.authorities[0].authority)) {
        this.idVendedorFiltro = this.userData.id
      }
      // console.log(this.fechaInicio)
      // console.log(this.fechaFin)
      if (this.fechaInicio === '') {
        this.fechaInicio = moment().format('YYYY-MM-DD')
      }

      if (this.fechaFin === '') {
        this.fechaFin = moment().format('YYYY-MM-DD')
      }
      this.isBusy = true
      await store
        .dispatch('comercial/VENTAS_FIND_ALL', {
          idEmpresa: this.idEmpresa,
          limit: this.perPage,
          query: this.query,
          page: this.page,
          almacen: -1,
          sortBy: 'ventaId%7CDESC',
          filtro_venta: this.statusFilter.id,
          vendedor: this.idVendedorFiltro,
          fecha_fin: this.fechaFin,
          fecha_inicio: this.fechaInicio,
        })
        .then(response => {
          this.items = response.items.map(venta => ({ ...venta, clienteRuc: venta.clienteDato.split('|')[2], clienteNombre: venta.clienteDato.split('|')[0], clienteDireccion: venta.clienteDato.split('|')[1] }))
          this.totalRows = response.totalRows
          this.totalItems = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
        })
        .catch(error => {
          this.showToast('Ha ocurrido un error', error, 'danger')
        })
      this.isBusy = false
    },
    openForm(type) {
      // this.formType = type
      // this.isToggleSidebar = true
      console.log(type)
      this.$router.push({ name: 'rt-comercial-nuevaventa' })
    },
    formatearMoneda(valor) {
      // Convertir el número en cadena con dos decimales
      const valorFormateado = valor.toFixed(2)

      // Agregar el prefijo "S/." y retornar
      return `S/. ${valorFormateado}`
    },
    getEdit(data) {
      this.formType = 'edit'
      this.isToggleSidebar = true
      console.log(data.item)
      this.dataEdit = data.item
    },
    deleteVenta(data) {
      this.$swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const partComprobante = data.item.numeroComprobante.split('-')
          const params = { nro_comprobante: partComprobante[1], serie: partComprobante[0], tipo_documento: data.item.tipoDocumento.tipoDocumentoId, venta_id: data.item.ventaId }
          this.$swal({
            title: 'Anulando en la Ose',
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            onOpen: async () => {
              this.$swal.showLoading()
              const service = 'comercial/VENTA_DELETE'
              await store.dispatch(service, params)
                .then(() => {
                  // this.items.forEach((item, index) => {
                  //   if (item.ventaId === data.item.ventaId) {
                  //     this.items[index].repuestaOse = response.respuesta_ose
                  //   }
                  // })
                  this.listarRegistros()
                  this.$swal.close()
                  this.showToast('Operación Extitosa', 'El comprobante se anulo', 'success')
                })
                .catch(error => {
                  this.$swal.close()
                  console.log(error)
                  this.showToast('Operación Error', error.errorMessage, 'danger')
                })
            },
          })
        }
      })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.showToast('Operación Extitosa', message, 'success')
      this.listarRegistros()
    },
    getColorAvatar() {
      const max = 7
      const min = 1
      const status = Math.floor(Math.random() * ((max + 1) - min) + min)
      if (status === 1) return 'primary'
      if (status === 2) return 'danger'
      if (status === 3) return 'secondary'
      if (status === 4) return 'warning'
      if (status === 5) return 'info'
      if (status === 6) return 'success'
      return 'primary'
    },
    // deleteVenta
    // generarGuia
    // generarNota
    // getConsultaOse
    generarNota(data) {
      const partComprobante = data.item.numeroComprobante.split('-')
      const params = { nro_comprobante: partComprobante[1], serie: partComprobante[0], tipo_documento: data.item.tipoDocumento.tipoDocumentoId, venta_id: data.item.ventaId }
      this.$swal({
        title: 'Crear nota de credito....',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading()
          const service = 'comercial/NOTA_CREDITO_CREATE'
          await store.dispatch(service, params)
            .then(response => {
              // this.items.forEach((item, index) => {
              //   if (item.ventaId === data.item.ventaId) {
              //     this.items[index].repuestaOse = response.respuesta_ose
              //   }
              // })
              console.log(response)
              this.$swal.close()
              this.showToast('Operación Extitosa', 'La nota de credito  fue creada', 'success')
              this.listarRegistros()
            })
            .catch(error => {
              this.$swal.close()
              console.log(error)
              this.showToast('Operación Error', error.errorMessage, 'danger')
            })
        },
      })
    },
    getConsultaOse(data) {
      const partComprobante = data.item.numeroComprobante.split('-')
      const params = { nro_comprobante: partComprobante[1], serie: partComprobante[0], tipo_documento: data.item.tipoDocumento.tipoDocumentoId, venta_id: data.item.ventaId }
      this.$swal({
        title: 'Consultando en la Ose',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading()
          const service = 'comercial/VENTA_CONSULTA_OSE'
          await store.dispatch(service, params)
            .then(response => {
              this.items.forEach((item, index) => {
                if (item.ventaId === data.item.ventaId) {
                  this.items[index].repuestaOse = response.respuesta_ose
                }
              })
              this.$swal.close()
              this.showToast('Operación Extitosa', 'El comprobante esta enviado en la Ose', 'success')
            })
            .catch(error => {
              this.$swal.close()
              this.showToast('Operación Error', error.errorMessage, 'danger')
            })
        },
      })
    },
    getReenvioOse(data) {
      const partComprobante = data.item.numeroComprobante.split('-')
      const params = { nro_comprobante: partComprobante[1], serie: partComprobante[0], tipo_documento: data.item.tipoDocumento.tipoDocumentoId, venta_id: data.item.ventaId }
      this.$swal({
        title: 'Reenvio en la Ose',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading()
          const service = 'comercial/VENTA_CONSULTA_OSE_REENVIO'
          await store.dispatch(service, params)
            .then(response => {
              this.items.forEach((item, index) => {
                if (item.ventaId === data.item.ventaId) {
                  this.items[index].repuestaOse = response.respuesta_ose
                }
              })
              this.$swal.close()
              this.showToast('Operación Extitosa', 'El comprobante esta enviado en la Ose', 'success')
            })
            .catch(error => {
              this.$swal.close()
              this.showToast('Operación Error', error.errorMessage, 'danger')
            })
        },
      })
    },
    chageStatusFilter() {
      console.log(this.statusFilter)
      this.listarRegistros()
    },
    getControlFise(data) {
      console.log(data)
      this.$router.push({ name: 'rt-comercial-controlfise', params: { venta: data.item } })
    },
    asignarFise(dataVenta) {
      console.log(dataVenta)
      this.$swal({
        title: 'Asigar vale FISE a este comprobante',
        html: `
      <div style="display: flex; flex-direction: column; text-align: left; gap: 10px;">
        <div>
          <label for="codigo" style="margin-bottom: 5px; display: block;">Código Fise:</label>
          <input id="codigo" class="form-control" placeholder="Ej: 1234567890123" inputmode="numeric" />
        </div>
        <div>
          <label for="numeroDecimal" style="margin-bottom: 5px; display: block;">Monto Fise:</label>
          <input id="numeroDecimal" class="form-control" placeholder="Ej: 10.5" type="number" step="any" />
        </div>
        <div>
          <label for="codigo2" style="margin-bottom: 5px; display: block;">Segundo Código Fise:</label>
          <input id="codigo2" class="form-control" placeholder="Ej: 1234567890123" inputmode="numeric" />
        </div>
        <div>
          <label for="numeroDecimal2" style="margin-bottom: 5px; display: block;">Segundo Monto Fise:</label>
          <input id="numeroDecimal2" class="form-control" placeholder="Ej: 10.5" type="number" step="any" />
        </div>
      </div>
    `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        preConfirm: () => {
          const codigo = document.getElementById('codigo').value
          const numeroDecimal = document.getElementById('numeroDecimal').value

          const codigo2 = document.getElementById('codigo').value
          const numeroDecimal2 = document.getElementById('numeroDecimal').value

          if (!/^\d{13}$/.test(codigo)) {
            this.$swal.showValidationMessage('El código debe tener exactamente 13 dígitos numéricos')
            return false
          }

          if (numeroDecimal === '' || numeroDecimal == null) {
            this.$swal.showValidationMessage('Debe ingresar un número decimal válido')
            return false
          }
          return { codigo, numeroDecimal, codigo2, numeroDecimal2 } // se pasa al .then(result)
        },
      }).then(async result => {
        if (result.isConfirmed && result.value) {
          this.$swal.close()
          this.$swal({
            title: 'Guardando el vale FISE',
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            onOpen: async () => {
              this.$swal.showLoading()
              const { codigoVale, numeroDecimal, codigoVale2, numeroDecimal2 } = result.value
              const partCliente = dataVenta.item.clienteDato.split('|')
              // Aquí va tu lógica con los datos válidos
              const dataFise = {
                codigo: codigoVale,
                detalle: dataVenta.item.detalleVenta[0].productoDato,
                direccionBeneficiario: partCliente[1],
                dniBeneficiario: partCliente[2],
                estado: true,
                estadoFise: 'PROCESADO',
                // fecha: moment().format('YYYY-MM-DD'),
                generaVenta: { ventaId: dataVenta.item.ventaId },
                montoConsumido: numeroDecimal,
                cliente: { idCliente: dataVenta.item.clienteId },
                idProducto: dataVenta.item.detalleVenta[0].productoId,
                montoFise: numeroDecimal,
                nombreBeneficiario: partCliente[0],
                origenVenta: { ventaId: dataVenta.item.ventaId },
                tipo: 'FISE',
                total: dataVenta.item.total,
              }
              // console.log(dataFise)
              await store
                .dispatch('comercial/CONTROL_FISE_CREATE', dataFise)
                .then(rp => {
                  console.log(rp)
                  // this.$swal.close()
                  this.showToast('Registro', 'Se registro el primer Vale Fise', 'success')
                })
                .catch(error => {
                  this.$swal.close()
                  this.showToast('Ha ocurrido un error', error, 'danger')
                })
              if (codigoVale2 !== '' && numeroDecimal2 !== '') {
                dataFise.codigo = codigoVale2
                dataFise.montoConsumido = numeroDecimal2
                dataFise.montoFise = numeroDecimal2
                await store
                  .dispatch('comercial/CONTROL_FISE_CREATE', dataFise)
                  .then(rp => {
                    console.log(rp)
                    // this.$swal.close()
                    this.showToast('Registro', 'Se registro el Segundo vale Fise', 'success')
                  })
                  .catch(error => {
                    this.$swal.close()
                    this.showToast('Ha ocurrido un error', error, 'danger')
                  })
              }
              this.$swal.close()
              this.listarRegistros()
            },
          })
        }
      })
    },
    asignarDelivery(dataVenta) {
      console.log(dataVenta)
      // TRABAJADOR_FIND_ALL_CARGO
      this.$swal({
        title: 'Cargando lista de deliveristas',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading()
          // console.log(dataFise)
          await store
            .dispatch('rrhh/TRABAJADOR_FIND_ALL_CARGO', { cargo: 'DELIVERISTA' })
            .then(rp => {
              this.$swal.close()
              const trabajadores = rp.items
              const nombres = trabajadores.map(trabajador => trabajador.nombreCompleto)

              this.$swal({
                title: 'Asignar deliverista a la venta',
                html: `
                  <select id="select-nombre" class="form-control">
                    ${nombres.map(nombre => `<option>${nombre}</option>`).join('')}
                  </select>
                `,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Guardar',
                cancelButtonText: 'Cancelar',
                customClass: {
                  confirmButton: 'btn btn-success',
                  cancelButton: 'btn btn-primary ml-1',
                },
                buttonsStyling: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then(async result => {
                // Cuando el usuario presiona "Guardar", puedes obtener el valor seleccionado
                if (result.isConfirmed) {
                  const selectedNombre = document.getElementById('select-nombre').value
                  // Aquí puedes realizar la lógica para guardar con el nombre seleccionado
                  // Ejemplo de cómo encontrar el objeto trabajador según el nombre seleccionado
                  const trabajadorSeleccionado = trabajadores.find(trabajador => trabajador.nombreCompleto === selectedNombre)
                  console.log('Trabajador seleccionado:', trabajadorSeleccionado)
                  // Aquí puedes continuar con tu lógica para guardar o hacer lo que necesites
                  await store
                    .dispatch('rrhh/TRABAJADOR_UPDATE_DELIVERY', { venta: dataVenta.item.ventaId, trabajador: trabajadorSeleccionado.idTrabajador })
                    .then(update => {
                      console.log(update)
                      this.showToast('Registro', 'Se Asigno el deliverista', 'success')
                      this.listarRegistros()
                    }).catch(error => {
                      console.error('Ha ocurrido un error:', error)
                      this.showToast('Ha ocurrido un error', error, 'danger')
                    })
                }
              }).catch(error => {
                console.error('Ha ocurrido un error:', error)
                this.showToast('Ha ocurrido un error', error, 'danger')
              })
            })
            .catch(error => {
              this.$swal.close()
              this.showToast('Ha ocurrido un error', error, 'danger')
            })
        },
      })
    },
    changeFechaVenta(selectedDates) {
      if (selectedDates.length === 2) {
        this.fechaInicio = moment(selectedDates[0]).format('YYYY-MM-DD')
        this.fechaFin = moment(selectedDates[1]).format('YYYY-MM-DD')
        // console.log(moment(selectedDates[0]).format('YYYY-MM-DD'))
        // console.log(moment(selectedDates[1]).format('YYYY-MM-DD'))
        this.listarRegistros()
      }
    },
    changeVendedorFilter() {
      console.log(this.vendedor)
      if (this.vendedor != null) {
        this.idVendedorFiltro = this.vendedor.idUsuario
      }
      this.listarRegistros()
    },
    formatNameVendedor(name) {
      console.log(name)
      const parts = name.split(' ')
      return `${parts[0]} ${parts[1].charAt(0)}.${parts[2].charAt(0)}.${parts.length > 3 ? parts[3].charAt(0) : ''}`
    },
    convertirNumeroALetras(num) {
      const unidades = ['', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve']
      const decenas = ['', 'diez', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa']
      const centenas = ['', 'cien', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos']
      const n = parseInt(num, 10)

      if (n < 10) return unidades[n]
      if (n < 100) return decenas[Math.floor(n / 10)] + (n % 10 !== 0 ? ` y ${unidades[n % 10]}` : '')
      if (n < 1000) return centenas[Math.floor(n / 100)] + (n % 100 !== 0 ? ` ${this.convertirNumeroALetras(n % 100)}` : '')
      if (n < 1000000) {
        const miles = Math.floor(n / 1000)
        const resto = n % 1000
        return (miles === 1 ? 'mil' : `${this.convertirNumeroALetras(miles)} mil`) + (resto !== 0 ? ` ${this.convertirNumeroALetras(resto)}` : '')
      }

      return 'Número demasiado grande'
    },
    async getPrintPdfTicke(data) {
      const row = data.item
      console.log(row)
      // eslint-disable-next-line new-cap
      const doc = new jsPDF('p', 'mm', [80, 566.93], true)
      doc.setProperties({
        title: 'FACTURACION ELECTRONICA PERU',
        author: 'UNIGAS',
        creator: 'UNIGAS',
      })
      const postx = 5
      let posty = 10
      doc.setFontSize(13)
      doc.addImage(row.almacen.img, 'JPEG', postx + 5, posty - 5, 60, 23)
      doc.setFontSize(9)
      posty += 30
      // y=y-4;
      doc.setFont('helvetica', 'bold')
      doc.text(`${'UNIVERSAL GAS S.R.LTDA.'}`, postx + 15, posty - 8)
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(8)
      const direccion = (row.almacen.direccion).toUpperCase()
      const direccionLines = doc.splitTextToSize(direccion, 75)
      doc.text(direccionLines, postx, posty - 4)
      // doc.text((row.almacen.direccion).toUpperCase(), postx, posty + 4)
      doc.setFontSize(8)
      // let type_comprobante = `${(data[0].tipo_comprobante).toUpperCase()} DE VENTA ELECTRÓNICA    ${documento_vent}`
      // if (data[0].tipo_comprobante == 'FACTURA') {
      //   type_comprobante = `${(data[0].tipo_comprobante).toUpperCase()} ELECTRÓNICA    ${documento_vent}`
      // }
      // posty += 4
      doc.setFont('helvetica', 'bold')
      doc.text(`RUC ${row.almacen.ruc}`, postx + 22, posty + 3)
      doc.setFont('helvetica', 'normal')
      doc.text('Cel. 941900064 Cel. 941900060', postx + 12, posty + 7)
      doc.setFontSize(9)
      doc.setFont('helvetica', 'bold')
      const pageWidth = doc.internal.pageSize.getWidth()
      doc.text(row.tipoDocumento.descripcion, pageWidth / 2, posty + 11, { align: 'center' })
      doc.setFontSize(8)
      doc.text(row.numeroComprobante, pageWidth / 2, posty + 15, { align: 'center' })
      doc.text('ADQUIRIENTE ', postx, posty + 19)
      doc.setFont('helvetica', 'normal')
      const clientePart = (row.clienteDato).split('|')
      let clienteDocumento = ''
      if (clientePart[2].length === 8) {
        clienteDocumento = 'DNI'
      }
      if (clientePart[2].length === 11) {
        clienteDocumento = 'RUC'
      }
      doc.text(`${clienteDocumento} : ${clientePart[2]}`, postx, posty + 23)
      doc.text(`${clientePart[0]}`, postx, posty + 26)
      const direccionLinesCliente = doc.splitTextToSize(clientePart[1], 70)
      doc.text(direccionLinesCliente, postx, posty + 29)
      doc.setFont('helvetica', 'bold')
      // posty -= 4
      doc.text('FECHA EMISIÓN:', postx, posty + 36)
      doc.text('FECHA DE VENC:', postx, posty + 40)
      doc.text('MONEDA:', postx, posty + 44)
      doc.text('FORMA PAGO :', postx + 25, posty + 44)
      doc.setFont('helvetica', 'normal')
      doc.text(row.fechaVenta, postx + 25, posty + 36)
      if (row.fechaVencimiento === null) {
        doc.text(`${moment(row.fechaVenta, 'DD/MM/YYYY').format('DD/MM/YYYY')}`, postx + 25, posty + 40)
      } else {
        doc.text(`${moment(row.fechaVencimiento, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD/MM/YYYY')}`, postx + 25, posty + 40)
      }
      doc.text('SOL', postx + 15, posty + 44)
      doc.text(row.formatoPago.descripcion, postx + 47, posty + 44)
      // Línea separadora en gris claro
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, posty + 45, 75, posty + 45)
      // doc.setFontType("normal");
      // doc.text((data[0].tipopago).toUpperCase(), x + 45, y + 28);
      /* if ((data.tipoventa).toUpperCase() !="CREDITO") {
          doc.text(data.formapago, x + 55, y + 28);
      } */
      // doc.text('---------------------------------------------------------------------', postx, posty + 32)
      posty += 12
      doc.setFontSize(7.5)
      doc.setFont('helvetica', 'bold')
      doc.text('[ CANT. ]', postx, posty + 36.5)
      doc.text('DESCRIPCION', postx + 13, posty + 36.5)
      doc.text('P/U', postx + 50, posty + 36.5)
      doc.text('TOTAL', postx + 62, posty + 36.5)
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(9)
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, posty + 38, 75, posty + 38)
      // doc.text('---------------------------------------------------------------------', postx, posty + 40)
      // doc.setFontType("normal");
      // doc.setFontType("blob");
      let f = posty + 42
      const rows = (row.detalleVenta).length
      doc.setFontSize(7)
      for (let i = 0; i < rows; i += 1) {
        const detVenta = row.detalleVenta[i]
        const producto = `[ ${detVenta.cantidad} ] ${detVenta.unidadMedidaDato} ${detVenta.productoDato}` // nombre_producto;
        // const cantidad = 1
        const pv = parseFloat(detVenta.precio).toFixed(2)
        const st = parseFloat(detVenta.subTotal).toFixed(2)
        // const undm = 'und'
        const productoLines = doc.splitTextToSize(producto, 45)
        // doc.text(`${parseFloat(cantidad).toFixed(2)} ${undm}`, postx, f)
        doc.text(productoLines, postx, f)
        doc.text(`${pv}`, postx + 50, f)
        doc.text(`${st}`, postx + 62, f)
        doc.setFontSize(7)
        // if (is_observacion_detalle == 1) {
        //   if (data[i].otra_observacion != '' && data[i].otra_observacion != null) {
        //     producto += `(${data[i].otra_observacion})`
        //   }
        // }
        // f = jspdf_responsi(doc, producto, postx + 14, f, 25)
        // f -= 4
        // doc.setFontSize(8);
        f += 6.5
      }
      // f += 8
      // doc.text('--------------------------------------------------------------------', postx, f)
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, f, 75, f)
      doc.setFontSize(8)
      // doc.setFontType("normal");
      let textCodeQr = `20362013802 | ${row.tipoDocumento.codigo} | ${row.numeroComprobante} | 0.00 | ${row.total} | ${moment(row.fechaVenta, 'DD/MM/YYYY').format('DD/MM/YYYY')} | 12 | ${clientePart[2]} |`
      if (row.tipoDocumento.tipoDocumentoId !== 12) {
        console.log(row)
        textCodeQr = row.repuestaOse.cadenaParaCodigoQr
      }
      const barcode = await QRCode.toDataURL(textCodeQr)
      const letraTotal = this.convertirNumeroALetras(row.total)
      const decimales = row.total.toFixed(2).split('.')[1]
      doc.setFontSize(8)
      // doc.text('', postx + 8, f + 4)
      f += -2
      doc.setFont('helvetica', 'bold')
      doc.text('Op. Exonerada:', postx + 27, f + 6)
      doc.text('S/ ', postx + 52, f + 6)
      doc.text(parseFloat(row.sub_total).toFixed(2), postx + 60, f + 6)

      doc.text('Op. Inafecta:', postx + 27, f + 10)
      doc.text('S/ ', postx + 52, f + 10)
      doc.text('0.00', postx + 60, f + 10)

      doc.text('Op. Gravada:', postx + 27, f + 14)
      doc.text('S/ ', postx + 52, f + 14)
      doc.text(parseFloat(0).toFixed(2), postx + 60, f + 14)

      doc.text('IGV:', postx + 27, f + 18)
      doc.text('S/', postx + 52, f + 18)
      doc.text(parseFloat(row.igv).toFixed(2), postx + 60, f + 18)

      doc.text('TOTAL:', postx + 27, f + 22)
      doc.text('S/', postx + 52, f + 22)
      doc.text(parseFloat(row.total).toFixed(2), postx + 60, f + 22)
      let recibido = row.efectivo === undefined ? row.total : row.efectivo
      recibido = recibido == null ? row.total : row.efectivo
      doc.text('RECIBIDO:', postx + 27, f + 26)
      doc.text('S/', postx + 52, f + 26)
      doc.text(parseFloat(recibido).toFixed(2), postx + 60, f + 26)
      const vuelto = recibido - row.total
      doc.text('VUELTO:', postx + 27, f + 30)
      doc.text('S/', postx + 52, f + 30)
      doc.text(parseFloat(vuelto < -1 ? 0 : vuelto).toFixed(2), postx + 60, f + 30)
      doc.setFont('helvetica', 'normal')
      // f += 10
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, f + 32, 75, f + 32)
      doc.setFontSize(7)
      const sonText = doc.splitTextToSize(`SON: ${letraTotal.toUpperCase()} CON ${decimales}/100 SOLES`, 70)
      const numLineas = sonText.length
      doc.text(sonText, postx, f + 35)
      doc.setFont('helvetica', 'bold')
      doc.text(`TIPO DE PAGO : [${row.tipoVenta.descripcion}]`, postx, f + 37 + (numLineas * 2))
      if (row.tipoVenta.tipoVentaId === 1) {
        doc.text(`CUOTA 1 ${moment(row.fechaVencimiento, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD/MM/YYYY')}(S/${row.total})`, postx, f + 40 + (numLineas * 2))
        f += 7
      } else {
        f += 5
      }

      if (row.observacion !== '') {
        const observacionText = doc.splitTextToSize(`OBSERVACION: ${row.observacion.toUpperCase()}`, 70)
        doc.text(`${observacionText}`, postx, f + 37 + (observacionText.length * 2))
        f += 7
      } else {
        f += 5
      }
      doc.setFont('helvetica', 'normal')
      // doc.setFontType("normal");
      doc.setFontSize(8)
      // doc.text("VEND: " + data.vendedor, x, f + 32);
      // doc.text("CAJE: " + data[0].usuario, x, f + 36);
      if (textCodeQr !== '') {
        doc.addImage(barcode, 'JPG', postx + 17, f + 37, 35, 35)
        // doc.setFontType("normal");
        f += 30
      } else {
        f += 5
      }
      // doc.text("DELIVERY SIN COSTO. ATENCION : 8AM - 9PM", x, f + 40);
      /* if (is_placa ==0) {
        doc.text('OBS:', x, f + 44);
    }else{
        doc.text('PLACA:', x, f + 44);
    }

    var initr = f+12;
     if(data[0].observacion != ''){

         $lineas_observaciones = data[0].observacion.split('<br>');
         $tam_observaciones = $lineas_observaciones.length;

         for ($j=0; $j < $tam_observaciones ; $j++) {

             $texto_observacion = $lineas_observaciones[$j];
             doc.text($texto_observacion, 23, initr);
             initr=parseInt(initr) + 12;
         }

     } */
      // f =initr;
      doc.setFontSize(8)
      const textDobleLinea = doc.splitTextToSize(`Representación impresa de la ${row.tipoDocumento.descripcion}, visite`, 70)
      doc.text(textDobleLinea, postx, f + 44)
      doc.setFont('helvetica', 'bold')
      doc.text('www.nubefact.com/20362013802', postx + 17, f + 48)
      doc.setFont('helvetica', 'normal')
      doc.text('No.034-005-0005315 Resumen: ', postx, f + 52)
      doc.text('/IjJCSwwC4Qx98g89jkTi4MFUTBEi6fARYeetox3lWA=', postx, f + 56)
      doc.text('!GRACIAS POR SU COMPRA!', postx + 15, f + 60)
      doc.setFontSize(7.5)
      // doc.save(documento_vent+".pdf");
      const blob = doc.output('blob')
      window.open(URL.createObjectURL(blob))
    },
    avatarText,
    showToast,
    showError,
  },

}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.invoice-filter-select-vendedor {
  min-width: 38vh;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 30vh;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style>
.w200{
  width: 350px !important;
}

</style>
